module.exports = __webpack_public_path__ + "static/media/christmasbell.7d6e3523.png";